

























































































import {Vue, Component, VModel, Prop} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import RefContactSliderSelector from "@/components/payroll/business/services/contact/RefContactSliderSelector.vue";
import {LocationOption,
	ServiceDTO, ServiceRecordDTO, UpdateServiceRecordPayload
} from "@/components/payroll/business/services/ServiceDTO";
import ServiceItem from "@/components/payroll/business/services/ServiceItem.vue";
import ServiceSliderSelector from "@/components/payroll/business/services/service/ServiceSliderSelector.vue";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalRadio from "@/components/v2/common/PortalRadio.vue";
import SelectOption from "@/components/common/SelectOption";
import PortalDate from "@/components/common/PortalDate.vue";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalAddress from "@/components/profile/branches/PortalAddress.vue";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";
import {ifValid, processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalTextarea from "@/components/common/PortalTextarea.vue";
import LocationSliderSelector from "@/components/payroll/business/services/locations/LocationSliderSelector.vue";
import ServiceOrchestrator from "@/services/ServiceOrchestrator";
import {IProfile} from "@/dto/IProfile";

@Component({
	computed: {
		SelectOption() {
			return SelectOption
		}
	},
	components: {
		LocationSliderSelector,
		PortalTextarea,
		PortalSelect,
		PortalAddress,
		PortalInput,
		ServiceView,
		PortalDate,
		PortalRadio, PortalCheckbox, ServiceSliderSelector, ServiceItem, RefContactSliderSelector, RightSideBar}
})
export default class ServiceLogUpdateSlider extends Vue {
	@VModel({type: Boolean, default: false})
	private model!: boolean;

	private req = new UpdateServiceRecordPayload()

	@Prop()
	private getLog!: () => ServiceRecordDTO | null

	private salesRate = 0

	private service: ServiceDTO | null = null

	get log(): ServiceRecordDTO {
		return this.getLog()!
	}

	private selectedLocation: LocationOption | null = null;

	private createService = false;
	private createLocation = false;

	get contact(): IProfile | null {
		if (!this.log) return null
		if (this.log.recipient.userId != this.$wss.getCurrent.userId) {
			return this.log.executor
		} else {
			return this.log.recipient
		}
	}

	get serviceFromLog(): ServiceDTO {
		return {
			id: this.log.serviceId,
			name: this.log.title,
			description: this.log.description,
			price: this.log.price,
			active: true,
			formattedPrice: this.log.formattedPrice,
			salesRate: this.salesRate,
			holder: this.log.executor,
			salable: this.log.salable,
			schedule: this.log.schedule,
			coefficient: null
		}
	}


	private selectService(service: ServiceDTO) {
		this.service = service;
		this.req.serviceId = this.service.id
	}

	private selectLocation(location: LocationOption) {
		this.selectedLocation = location
		this.selectedLocation.selected(this.req)
	}

	mount(visible: boolean) {
		if (visible) {
			this.req.startDate = this.log.startDate
			this.req.endDate = this.log.endDate
			this.salesRate = this.log.salesRate * 100
			Application.startLoading()
				.then(this.loadService)
				.finally(Application.stopLoading)
		} else {
			this.$emit('update', this.log)
		}
	}

	private loadService(): Promise<void> {
		return ServiceOrchestrator.getById(this.log.serviceId).then(
			res => {
				this.service = res.data
			},
			err => processError(err, this)
		)
	}

	private update() {
		ifValid(this, () => {
			Application.startLoading()
			this.req.id = this.log.id
			this.req.serviceId = this.service ? this.service.id : this.log.serviceId
			this.req.assigneeId = this.log.executor.id
			ServiceLogOrchestrator.updateLog(this.req).then(
				res => {
					Application.stopLoading()
					this.$emit("input", false)
					this.$emit("update", res.data)
				},
				err => processError(err, this)
			)
		})
	}

	private setService(service: ServiceDTO): void {
		this.log.serviceId = service.id
		this.log.title = service.name
		this.log.price = service.price
		this.log.formattedPrice = service.formattedPrice
		this.service = service
	}
}
